"use client"

export type TimeSpan = "minute" | "second"
export type AnalysisType = "query" | "object detection" | "point" | "caption"
export type CalculatorTab = "video" | "computer" | "image"
export type ImageSkill = AnalysisType

export type ImageSkillConfig = {
  label: string
  sliderLabel: string
  stops: {
    label: string
    tokens: number
  }[]
}
export type BundlingMode = "bundled" | "serial"

export const FRAME_RATE_OPTIONS: Record<TimeSpan, number[]> = {
  minute: [1, 2, 6],
  second: [1, 2, 4, 15, 30, 60],
}

export const FRAME_LABELS: Record<TimeSpan, string> = {
  minute: "Frames Per Minute",
  second: "Frames Per Second",
}

export const ANALYSIS_OPTIONS: { value: AnalysisType; label: string }[] = [
  { value: "query", label: "Query" },
  { value: "object detection", label: "Object detection" },
  { value: "point", label: "Point" },
  { value: "caption", label: "Caption" },
]

export const IMAGE_SKILL_CONFIGS: Record<ImageSkill, ImageSkillConfig> = {
  query: {
    label: "Query",
    sliderLabel: "Answer complexity",
    stops: [
      { label: "Simple", tokens: 15 },
      { label: "Medium", tokens: 30 },
      { label: "Complex", tokens: 100 },
    ],
  },
  "object detection": {
    label: "Object detection",
    sliderLabel: "Objects detected",
    stops: [
      { label: "One", tokens: 3 },
      { label: "A few", tokens: 12 },
      { label: "10+", tokens: 30 },
    ],
  },
  point: {
    label: "Point",
    sliderLabel: "Points detected",
    stops: [
      { label: "One", tokens: 2 },
      { label: "A few", tokens: 6 },
      { label: "10+", tokens: 20 },
    ],
  },
  caption: {
    label: "Caption",
    sliderLabel: "Caption length",
    stops: [
      { label: "Short", tokens: 10 },
      { label: "Medium", tokens: 24 },
      { label: "Long", tokens: 40 },
    ],
  },
}

export const AI_INSPECTION_STOPS = [3, 15, 30]
export const DEFAULT_AI_INSPECTION_INDEX = 1

export const BUNDLING_PRESETS: Record<BundlingMode, { label: string; rangeLabel: string; avgAsksPerCall: number }> = {
  bundled: { label: "Bundled", rangeLabel: "3–5 asks/call", avgAsksPerCall: 4 },
  serial: { label: "Serial", rangeLabel: "1–2 asks/call", avgAsksPerCall: 1.5 },
}

export const RETRY_PERCENT_MAX = 20

export const SECONDS_PER_UNIT: Record<TimeSpan, number> = {
  minute: 60,
  second: 1,
}

export const SECONDS_PER_HOUR = 60 * 60
